/**
 * reCAPTCHA Enterprise Service
 *
 * Servicio reutilizable para obtener tokens de reCAPTCHA Enterprise v3.
 * Se puede usar en cualquier parte de la aplicación para proteger acciones.
 *
 * Uso:
 *   import recaptchaService from '@/services/recaptcha.service'
 *
 *   const token = await recaptchaService.execute('LOGIN')
 *   // Enviar token al backend para verificación
 */

import { RECAPTCHA_SITE_KEY } from '@/utils/globals'

export default {
  /**
   * Ejecuta reCAPTCHA y retorna un token para enviar al backend.
   * El token expira después de 2 minutos.
   * @param {string} action - Nombre de la acción a proteger (ej: 'LOGIN', 'REGISTER', 'SUBMIT_FORM')
   * @returns {Promise<string>} Token de reCAPTCHA
   */
  async execute(action) {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha || !window.grecaptcha.enterprise) {
        reject(new Error('reCAPTCHA Enterprise no está cargado.'))
        return
      }

      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action })
          resolve(token)
        } catch (error) {
          reject(error)
        }
      })
    })
  }
}
